var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoLibraryB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8V2C11 1.45 10.55 1 10 1H4C3.45 1 3 1.45 3 2V8C3 8.55 3.45 9 4 9H10C10.55 9 11 8.55 11 8ZM5.5 6L6.515 7.355L8 5.5L10 8H4L5.5 6ZM1 3V10C1 10.55 1.45 11 2 11H9V10H2V3H1Z",
    fill: "#1C1C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLibraryB);
export default __webpack_public_path__ + "static/media/photo-library_b.64d0ebdeececebe56d2d74abf589bb08.svg";
export { ForwardRef as ReactComponent };